import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromUserGroup from '../_reducers/userGroup';

export const selectUserGroupState =
  createFeatureSelector<fromUserGroup.UserGroupState>('userGroups');

export const selectAllUserGroups = createSelector(selectUserGroupState, fromUserGroup.selectAll);
